import {
  updateConnectedGatewaysListData,
  updateDisconnectedGatewaysListData,
  updateGatewaysWithSourcesResultsReady,
} from "@src/reducers/your-reducer";
import apiUseCases from "../api";
import store from "@src/reducers/store";

export const loadGatewaysWithSourcesListsData = async () => {
  const response = await apiUseCases.getGatewaysWithSources();

  if (response) {
    store.dispatch(
      updateConnectedGatewaysListData(response.connectedGatewaysListData),
    );

    // this is always an empty array for now, backend does not return disconnected gateways
    store.dispatch(
      updateDisconnectedGatewaysListData(response.disconnectedGatewaysListData),
    );

    store.dispatch(updateGatewaysWithSourcesResultsReady(true));
  }
};
